// extracted by mini-css-extract-plugin
module.exports = {"loading":"loading_loading__1GRCx"};